import React from 'react';
import { useAuth } from 'context/auth-context';

const AuthenticatedApp = React.lazy(() => import('./authenticated-app'));
const UnAuthenticatedApp = React.lazy(() => import('./unauthenticated-app'));

/**TODO: Have an un-authorized page, in-place of UnAuthenticatedApp
 * which will be used to show user is unothrized, it will be used to
 * ask user to authenticate by refreshing the page
 */
function App() {
  const { user } = useAuth();
  return (
    <React.Suspense fallback={<span>....</span>}>
      {user ? <AuthenticatedApp></AuthenticatedApp> : <UnAuthenticatedApp></UnAuthenticatedApp>}
    </React.Suspense>
  );
}

export default App;
